import { useAuth } from 'react-oidc-context';
import { useEffect, useState } from 'react';
import 'src/styles/authErrorDialog.css';
 
const AuthErrorDialog = () => {
  const auth = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (auth.error) {
      setShow(true);
    }
  }, [auth.error]);

  if (!show) return null;

  return (
    <div className="auth-error-backdrop">
      <div className="auth-error-dialog">
        <h2>Authentication Error</h2>
        <p>{auth.error?.message}</p>
        <button onClick={() => setShow(false)}>Close</button>
      </div>
    </div>
  );
};

export default AuthErrorDialog;